// src/docs/DocsWalletDisconnected.js
import React from "react";
import { Container, Typography } from "@mui/material";

const DocsWalletDisconnected = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        Wallet Disconnected Modal
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        The Wallet Disconnected Modal is a key feature of CrowdLaunch that alerts users when their cryptocurrency wallet is not connected. 
        This modal ensures that you are aware of your disconnected status and guides you to connect your wallet to access full platform features.
      </Typography>

      {/* When Does It Appear? */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        When Does It Appear?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        The modal is automatically displayed when you try to perform actions that require a connected wallet, such as purchasing tokens, staking LNCH, or managing projects. 
        It serves as a safeguard to prevent unauthorized transactions or actions on the platform.
      </Typography>

      {/* How It Works */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        How It Works
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        When no wallet is connected, the modal pops up with a clear message stating that your wallet is disconnected. 
        It provides a prominent "Connect Wallet" button that, when clicked, initiates the wallet connection process.
        This seamless integration ensures that you can quickly connect your wallet and proceed with your actions.
      </Typography>

      {/* Security and User Experience */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Security and User Experience
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        By preventing unauthorized interactions, the Wallet Disconnected Modal enhances security on CrowdLaunch. 
        It ensures that all transactions are properly authenticated and that your assets remain secure.
        The modal is designed with clear instructions and a simple interface to provide an optimal user experience.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        The Wallet Disconnected Modal is an essential part of the CrowdLaunch platform, ensuring that users are always securely connected before performing any critical operations. 
        This not only protects your assets but also guarantees a smooth and secure user experience.
      </Typography>
    </Container>
  );
};

export default DocsWalletDisconnected;
